import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollProgress from "@/components/ScrollProgress";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollProgress />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(20,20,22,0.9)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
